import { Component, NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { ApiResponse } from 'src/app/models/models';
import { State } from 'src/app/state';
import { error_toast } from 'src/app/utils/toast.util';
import { is_nothing } from 'src/app/utils/utils';
import { invoicer_queriable_to_item } from '../payments.component';
import { ContributorView } from 'src/app/models/invoicer_query.models';


@Component({
  selector: 'app-transcore',
  templateUrl: './transcore.component.html',
  styleUrls: ['../edes/ede.less'], // Re-using EDE styles to maintain consistency
})
export class TranscoreComponent {
  id: string;
  amount: number | null = null; 
  result: ContributorView;
  
  working = {
    main: false,
  };

  constructor(private api: ApiService, private router: Router) {
    if (is_nothing(State.active_invoicer)) {
      this.router.navigate(['cashier', 'pay']);
    }
  }

  get invoicer_name(): string {
    return State.active_invoicer?.name || 'Servicio';
  }

  query() {
    if (!this.id) return;

    this.working.main = true;
    
    // Assuming a generic query method exists or a specific one for transcore/donafp.
    // Replace 'query_transcore' with the actual method name in your ApiService.
    this.api.query_transcore(this.invoicer_name, this.id, (response) => {
      this.working.main = false;
      if (response.succeeded) {
        this.result = response.data;
        // Ensure the document is set from the response or the input
        this.result.document = this.result.document || this.id; 
      } else {
        error_toast(response.error.message);
      }
    });
  }

  // ID Producto Donation DOP en Transcore
  get product_id(): number { 
    return 13;
  }

  pay() {
    if (!this.amount) return;

    State.payment_package = [
      {
        name: this.result.name,
        document: this.result.document,
        invoicer: invoicer_queriable_to_item(State.active_invoicer),
        type: 1, // Treated as prepay
        payloads: [
          {
            invoice_id: this.product_id + '',
            concept: 'Pago',
            amount: this.amount,
            currency: '214',
          },
        ],
      },
    ];
    this.router.navigate(['cashier', 'apply-payment']);
  }
}